
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[filename]",
      function () {
        return require("private-next-pages/blog/category/[filename].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[filename]"])
      });
    }
  